import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "../../Css/About.css";
import packkyImage from "../../assets/Why Choose us.webp";
import Grid from "../../assets/Grid.png";
import imag2 from "../../assets/Our_Story_1.webp";
import imag3 from "../../assets/Our_Story_2.webp";
import imagw from "../../assets/CTA.webp";
import DiscoverBlogs from "../LandingPage/DiscoverBlogs";
import Navbar from "./Navbar";
import Footer from "./Footer";
// import { Script } from "../../Utils/Script";

const AboutSection = () => {
  useEffect(() => {
    const currentUrl = window.location.href;
    const encodedUrl = encodeURIComponent(currentUrl);

    const script = document.createElement("script");
    script.src = `https://packky.com/SeoBix/seo_injection.php?webid=cd8435ad15b4e27805d9e08fbaa8d536&url=${encodedUrl}&baseUrl=https%3A%2F%2Fpackky.com`;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

// useEffect(() => {
//   Script();
// }, []);

  return (
    <>
    <Helmet>
        <title> About Packky — Delivery Management Platform Powered by Chaafo </title>

        <meta
          name="description"
          content="Learn how Packky is transforming last-mile delivery for restaurants and businesses across India with smart routing, real-time tracking, and seamless operations."
        />
      </Helmet>
    <Navbar/>
     <div className="main-box-1 pt-[90px] sm:pt-[100px] md:pt-5 overflow-hidden">
  <div className="main-box">
    <section className="about-us bg-gray-100 py-8 sm:py-10 md:py-12">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-center text-center mt-3">
          <div className="w-full">
            <h5 className="about-title !text-[28px] !font-bold !sm:text-[22px] !md:text-[26px] !lg:text-[28px]">
              ABOUT US
            </h5>

            <h2 className="contact-title1 mx-auto mt-4 max-w-[520px] text-center text-[22px] text-[#212529] sm:text-[26px] md:text-[26px] leading-[1.15] font-semibold">
              Transforming The Way <br />
              <span>Businesses Deliver</span>
            </h2>

            <p className="contact-subtitle1 mx-auto mt-4 max-w-[1000px] px-1 text-[16px] sm:text-[17px] md:text-[20px] lg:text-[22px] leading-6 md:leading-7 text-[#5b6470]">
              In today’s fast-paced world, timely and reliable deliveries aren’t a luxury — they’re essential. At Packky (powered by Chaafo), our mission is to help businesses manage their logistics with speed, simplicity, and complete transparency. We’re building smarter tools that make deliveries seamless and stress-free, so you can focus on growing your business while we handle the last mile.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>

  {/* WHY CHOOSE US */}
  <div className="main-box1 mt-3 sm:mt-5">
    <section className="about-us-2 bg-white py-8 sm:py-10 md:py-12">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mt-2">
          <div className="mb-6 sm:mb-8 w-full text-center">
            <h3 className="font-bold mt-4 sm:mt-8 md:mt-12 lg:mt-16 text-[#212529] text-[24px] sm:text-[26px] md:text-[28px]">
              Why Choose Us?
            </h3>
          </div>

          <div className="flex flex-col items-center gap-8 md:flex-row md:items-center md:justify-between">
            <div className="w-full md:w-1/2 text-center">
              <img
                src={packkyImage}
                alt="About Us"
                className="mx-auto h-auto w-full max-w-[420px] md:max-w-full rounded"
              />
            </div>

            <div className="w-full md:w-1/2 text-center md:text-left">
              <div className="mb-6">
                <h4 className="font-bold text-[20px] text-[#212529] sm:text-[22px] heading-text-4 mb-3">
                  Speed & Efficiency
                </h4>
                <p className="paragarp-text text-[15px] sm:text-[18px] leading-6">
                  Optimized routing and instant notifications, we cut down delivery times and enhance productivity.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="font-bold text-[20px] text-[#212529] sm:text-[22px] heading-text-4 mb-3">
                  Real-time Tracking
                </h4>
                <p className="paragarp-text text-[15px] sm:text-[18px] leading-6">
                  Always know where your shipments are and keep customers informed with live updates.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="font-bold text-[20px] text-[#212529] sm:text-[22px] heading-text-4 mb-3">
                  Smart Automation
                </h4>
                <p className="paragarp-text text-[15px] sm:text-[18px] leading-6">
                  Reduce manual errors with automated order processing and smooth fulfillment.
                </p>
              </div>

              <div>
                <h4 className="font-bold text-[#212529] text-[20px] sm:text-[22px] heading-text-4 mb-3">
                  Scalability & Flexibility
                </h4>
                <p className="paragarp-text text-[15px] sm:text-[18px] leading-6">
                  Whether 10 or 10,000 deliveries a day, Packky (powered by Chaafo) scales effortlessly with your business.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  {/* OUR STORY */}
  <div
    className="main-box2 mt-1"
    style={{
      backgroundImage: `url(${Grid})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundColor: "rgba(240, 237, 252, 1)",
    }}
  >
    <section className="about-us-2 py-8 sm:py-10 md:py-12">
      <div className="mx-auto w-full max-w-[1200px] px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center">
          <div className="main-box-box w-full">
            <div className="mt-1">
              <div className="w-full">
                <h3 className="mt-3 sm:mt-5 text-center text-[#212529] font-bold text-[24px] sm:text-[26px] md:text-[28px]">
                  Our Story
                </h3>

                {/* Row 1 */}
                <div className="mt-6 grid grid-cols-1 items-center gap-x-10 gap-y-6 md:grid-cols-2">
                  <div className="w-full">
                    <div className="service-image-3">
                      <img
                        src={imag2}
                        alt="Service"
                        className="mx-auto h-auto w-full max-w-[430px] md:max-w-full"
                      />
                    </div>
                  </div>

                  <div className="w-full">
                    <div className="service-card-67 text-center md:text-left">
                      <p
                        className="!text-[20px] sm:!text-[22px] mb-4"
                        style={{ color: "rgba(100,160,255,1)" }}
                      >
                        Where We Started
                      </p>
                      <p className="text-center md:text-left text-gray-500 text-[15px] sm:text-base md:leading-7 leading-6">
                        We began with a simple vision — to remove chaos from deliveries and create a system that works for everyone: businesses, drivers, and customers. What started as an idea has grown into a logistics platform that redefines efficiency and customer satisfaction.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Row 2 */}
                <div className="mt-8 grid grid-cols-1 items-center gap-x-10 gap-y-6 md:grid-cols-2">
                  <div className="order-2 w-full md:order-1">
                    <div className="service-card-67 text-center md:text-left">
                      <p
                        className="!text-[20px] sm:!text-[22px] mb-4"
                        style={{ color: "rgba(179,100,255,1)" }}
                      >
                        Who We Are Today
                      </p>
                      <p className="text-center md:text-left text-gray-500 text-[15px] sm:text-base md:leading-7 leading-6">
                        Our team is a mix of innovators and problem-solvers who believe the future of delivery should be fast, frictionless, and future-ready. Every feature we build aims to make your deliveries smarter, easier, and built for growth.
                      </p>
                    </div>
                  </div>

                  <div className="order-1 w-full md:order-2">
                    <div className="service-image-3">
                      <img
                        src={imag3}
                        alt="Service"
                        className="mx-auto h-auto w-full max-w-[430px] md:max-w-full"
                      />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  {/* CTA */}
  <div className="main-box-5 card-h bg-gray-100 p-3 sm:p-5">
    <section className="about-p py-6 sm:py-8">
      <div className="mx-auto w-full max-w-7xl px-0 sm:px-4 lg:px-8">
        <div className="flex flex-wrap mt-3 sm:mt-5">
          <div className="w-full">
            <div
              className="banner-box3 mx-auto rounded-3xl overflow-hidden relative"
              style={{
                background:
                  "linear-gradient(-135deg, #FDFEFF 20%, #CEEBFF 70%, #129EFF 100%)",
                border: "0.5px solid #ccc",
                minHeight: "300px",
                maxWidth: "1200px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
              }}
            >
              <div className="flex flex-col md:flex-row h-full">
                <div className="w-full md:w-1/2 lg:w-7/12 flex flex-col justify-center p-5 sm:p-6 md:p-5 text-center md:text-left">
                  <h4 className="text-[#212529] max-w-md mx-auto md:mx-0 md:ml-5 md:text-[28px] text-[22px] sm:text-2xl font-bold mb-3">
                    Join the Future of Delivery
                  </h4>

                  <p className="text-gray-600 mx-auto md:mx-0 md:ml-5 text-[15px] sm:text-[18px] leading-6">
                    At Packky (powered by Chaafo), we are more than just a service. We're your logistics partner. We're your partner in need when you're looking for last-mile delivery solutions, fleet management, or the smooth integration of your existing systems.
                    <br />
                    Let's advance the world one delivery at a time.
                  </p>

                  <button className="mt-6 mx-auto md:mx-0 md:ml-5 mb-6 w-fit text-[#0d6efd] flex items-center rounded-full bg-white px-4 py-2 text-sm sm:text-base font-bold">
                    Sign Up for Free →
                  </button>
                </div>

                <div className="w-full md:w-1/2 lg:w-5/12 flex items-end justify-center relative px-4 md:px-0">
                  <img
                    src={imagw}
                    alt="Service"
                    className="h-auto w-full max-w-[360px]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <DiscoverBlogs />
</div>
     <Footer/>
    </>
  );
};

export default AboutSection;